import { useContext } from 'react';

import { OrderBookWsContext } from './order-book-ws-context';

export const useOrderBookWsContext = () => useContext(OrderBookWsContext);
